export const MESSAGES = {
  UPLOAD_ERROR_FALLBACK: 'Upload failed. Please try again.',
  DRAGGER_TEXT: 'Click or drag file to this area to upload',
  DRAGGER_HINT: 'Support for a single or bulk upload.',
  UPLOADED_DOCUMENTS_TITLE: 'Uploaded documents',
  UPLOADED_ON_PREFIX: 'Uploaded on',
  DELETE_DOCUMENT_TITLE: 'Delete this document?',
  DELETE_DOCUMENT_CONFIRM: 'Are you sure you want to delete this document? This action cannot be undone.',
  DELETE_BUTTON_LABEL: 'Delete',
  CANCEL_BUTTON_LABEL: 'Cancel'
}
